//门禁管理
export default [
  {
    path: '/smartLock',
    component: () => import('../pages/smartLockManage/smartLock.vue'),
    name: 'smartLock',
    title: '门禁设备管理',
    meta: {
      title: '门禁设备管理',
    },
  },
]
